/**
 * Аналог UserGender.java
 * @see one/comp/user/UserGender.java
 *
 * только для значений используются строки, чтобы понятнее было, что приходит в json
 */
export enum UserGender {
    UNKNOWN,
    MALE,
    FEMALE
}
